module.exports = {"511825100":"城厢镇","511825101":"始阳镇","511825102":"思经镇","511825103":"喇叭河镇","511825104":"小河镇","511825105":"仁义镇","511825106":"新场镇","511825206":"乐英乡","511825210":"新华乡","511825212":"兴业乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511825.json
// module id = 2516
// module chunks = 0